import React, { useRef, useState } from "react";
import PaddingBox from "../../../Shared/PaddingBox";
import FroalaTextEditor from "../../../../FroalaEditor/children/FroalaTextEditor";
import styled from "styled-components";
import NewAIPrompt from "../../../../NewAiPrompt";
import { handleAiAssistantIcon } from "../../../../FroalaEditor/children/FroalaHelpers";
import ReactDOM from "react-dom";
import StyleInfoCard from "../../../Main/StyleTab/StyleInfoCard";
import SettingsSlider from "../../../Shared/SettingsSlider";
import { charLimitInASegment } from "../../../../SegmentSettings";
import { useSelector } from "react-redux";
import { getSelectedSegmentCharCount } from "../../../../../redux/selectors/segmentBuilderSelectors";
import { getHtmlCharCount } from "../../../Main/SegmentsTab/SegmentsTabHelpers";
const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 85vh;
  width: 100%; // Use 100% instead of fixed 400px
  max-width: 100%; // Set a max-width instead of fixed width
  background-color: white;
  overflow-y: auto;
  padding: 0px 10px 0px 0px;
  margin-top: -10px;
  overflow-x: hidden;

  /* Make responsive for different screen sizes */
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0px 5px 0px 0px;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

function TextForm({
  setProp,
  fontSize,
  text,
  padding,
  increasePadding,
  decreasePadding,
  isApplyPaddingOnAllSides,
  allSidePadding,
  handlePaddingCheckBox,
  handleSliderPaddingChange,
  handlePaddingChange = () => {},
  handleLineHeightChange,
  handleHeadingPropsChange,
  handleParagraphPropsChange,
  headingProps,
  paragraphProps,
  lineHeight,
}) {
  const [showAiPrompt, setShowAiPrompt] = useState(false);

  const selectedSegmentCharCount = useSelector(getSelectedSegmentCharCount);
  const currentEditorCharCount = text ? getHtmlCharCount(text) : 0;

  const editorCharLimit =
    currentEditorCharCount + (charLimitInASegment - selectedSegmentCharCount);

  const editorRef = useRef(null);

  const handleFroalaCustomization = (FroalaEditor) => {
    handleAiAssistantIcon(FroalaEditor, setShowAiPrompt);
  };

  return (
    <MainDiv>
      <FroalaTextEditor
        name={`text_body`}
        id={1}
        value={text}
        onChange={(e) => setProp((props) => (props.text = e), 500)}
        handleEditorCustomization={handleFroalaCustomization}
        editorRef={editorRef}
        placeholder="Add Text Here"
        label={"Text Field"}
        lineHeight={lineHeight}
        headingProps={headingProps}
        paragraphProps={paragraphProps}
        disableAtCharLimit
      />

      {/* Character count indicator */}
      <div
        style={{
          textAlign: "right",
          fontSize: "12px",
          color:
            selectedSegmentCharCount > charLimitInASegment ? "#ff4d4f" : "#999",
          margin: "5px 16px 10px 16px",
        }}
      >
        {selectedSegmentCharCount > charLimitInASegment
          ? `${charLimitInASegment}/${charLimitInASegment} (Segment character limit exceeded by ${
              selectedSegmentCharCount - charLimitInASegment
            } characters)`
          : `${selectedSegmentCharCount}/${charLimitInASegment}`}
      </div>

      <div style={{}}>
        <StyleInfoCard
          title={"Heading Text"}
          background="none"
          borderBottom
          applyButton={false}
          selectedFont={headingProps?.fontFamily}
          selectedColor={headingProps?.fontColor}
          handleFontChange={(font) =>
            handleHeadingPropsChange(font, "fontFamily")
          }
          inputValue={headingProps?.fontSize}
          handleInputValueChange={(size) =>
            handleHeadingPropsChange(size, "fontSize")
          }
          onConfirmCustomColor={(color) =>
            handleHeadingPropsChange(color, "fontColor")
          }
          tooltip="Changes the settings for any text in the block that is formatted as a 'Header'"
          handleResetFontColor={() =>
            handleHeadingPropsChange(null, "resetKey")
          }
          type="Header"
        />

        <StyleInfoCard
          title={"Paragraph Text"}
          background="none"
          borderBottom
          applyButton={false}
          selectedFont={paragraphProps?.fontFamily}
          selectedColor={paragraphProps?.fontColor}
          handleFontChange={(font) =>
            handleParagraphPropsChange(font, "fontFamily")
          }
          inputValue={paragraphProps?.fontSize}
          handleInputValueChange={(size) =>
            handleParagraphPropsChange(size, "fontSize")
          }
          onConfirmCustomColor={(color) =>
            handleParagraphPropsChange(color, "fontColor")
          }
          tooltip="Changes the settings for any text in the block that is formatted as a 'Paragraph'"
          handleResetFontColor={() =>
            handleParagraphPropsChange(null, "resetKey")
          }
          type={"Paragraph"}
        />

        <SettingsSlider
          title="Line Spacing"
          sliderValue={lineHeight}
          onValueChange={handleLineHeightChange}
          min={1}
          max={2}
          containerStyle={{
            padding: "16px",
          }}
          valueLabel={false}
          step={0.05}
          allowDecimal
        />

        <PaddingBox
          padding={padding}
          increasePadding={increasePadding}
          decreasePadding={decreasePadding}
          isApplyPaddingOnAllSides={isApplyPaddingOnAllSides}
          allSidePadding={allSidePadding}
          handlePaddingCheckBox={handlePaddingCheckBox}
          handleSliderPaddingChange={handleSliderPaddingChange}
          handleSpacingChange={handlePaddingChange}
          title="Padding"
          checkbox={false}
          containerStyle={{
            padding: "16px 0px",
          }}
        />
      </div>

      {showAiPrompt &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              zIndex: 6522299,
              right: "35vw",
              top: "25vh",
              overflow: "auto",
            }}
          >
            <NewAIPrompt
              modalWidth="350px"
              onCloseIconPress={() => setShowAiPrompt(false)}
            />
          </div>,
          document.body // You can also use a different element if needed
        )}
    </MainDiv>
  );
}

export default TextForm;
